var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1412 24C47.1412 11.2185 36.7798 0.857117 23.9983 0.857117C11.2169 0.857117 0.855469 11.2185 0.855469 24C0.855469 36.7814 11.2169 47.1428 23.9983 47.1428C36.7798 47.1428 47.1412 36.7814 47.1412 24ZM3.74833 24C3.74833 12.8162 12.8146 3.74997 23.9983 3.74997C35.1821 3.74997 44.2483 12.8162 44.2483 24C44.2483 35.1837 35.1821 44.25 23.9983 44.25C12.8146 44.25 3.74833 35.1837 3.74833 24ZM16.157 16.1587C16.7219 15.5938 17.6377 15.5938 18.2026 16.1587L23.9984 21.9544L29.7941 16.1587C30.359 15.5938 31.2748 15.5938 31.8397 16.1587C32.4045 16.7236 32.4045 17.6394 31.8397 18.2043L26.0439 24L31.8397 29.7957C32.4045 30.3606 32.4045 31.2764 31.8397 31.8413C31.2748 32.4062 30.359 32.4062 29.7941 31.8413L23.9984 26.0456L18.2026 31.8413C17.6377 32.4062 16.7219 32.4062 16.157 31.8413C15.5922 31.2764 15.5922 30.3606 16.157 29.7957L21.9528 24L16.157 18.2043C15.5922 17.6394 15.5922 16.7236 16.157 16.1587Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.27e00ccc9a1a31701a8fc8b85d0cd9b0.svg";
export { ForwardRef as ReactComponent };